import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DLRootCertificate } from './root-certificate';
import { DLRootCertificateService } from './root-certificate.service';
import { lookupParam } from '../../nav/utils';
import { NotifierService } from '../../ui';

@Injectable()
export class DLRootCertificateResolver implements Resolve<DLRootCertificate> {

  constructor(
    private router: Router,
    private rootCertificateService: DLRootCertificateService,
    private notifier: NotifierService,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): DLRootCertificate | Observable<DLRootCertificate> | Promise<DLRootCertificate> {
    return new Promise<DLRootCertificate>(async (resolve, reject) => {

      let rootCertificate_id = lookupParam(route, 'root_certificate_id');

      this.notifier.startProgress();

      this.rootCertificateService
        .rootCertificate(rootCertificate_id)
        .subscribe((rootCertificate) => {
          
          if(rootCertificate) {
            return resolve(rootCertificate);
          }
          else {
            this.router.navigate(['documents-ledger', 'root-certificates']);
            return resolve(null);
          }
        });
    });
  }
}